"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _noticeRegisterActions = require("../register/noticeRegisterActions");
var _noticeHistoryActions = require("../history/noticeHistoryActions");
const noticeReducers = {
  noticeRegister: _noticeRegisterActions.noticeRegisterReducer,
  noticeHistory: _noticeHistoryActions.noticeHistoryReducer
};
var _default = exports.default = noticeReducers;